module.exports = __webpack_public_path__ + "assets/img/算法分批.c3c9949c.jpg";